import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'app-group-select',
  templateUrl: './group-dropdown.component.html',
  styleUrls: ['./group-dropdown.component.scss'],
  standalone: false,
})
export class GroupDropdownComponent {
  @Input() disabled: boolean = false; // Disable the dropdown
  @Input() groups: any[] = []; // List of groups
  @Input() groupIdProp: string = 'id'; // Field representing the group id
  @Input() groupDisplayProp: string = 'name'; // Field to display for groups
  @Input() groupItemsProp: string = 'items'; // Field representing the items in the group
  @Input() itemIdProp: string = 'items'; // Field representing the items
  @Input() itemDisplayProp: string = 'name'; // Field to display for items
  @Input() selectedItems: any[] = []; // List of selected items
  @Input() hideGroupSelection: boolean = false; // Hide group selection

  @Output() groupSelected = new EventEmitter<any>();
  @Output() itemSelected = new EventEmitter<any>();

  @HostListener('document:click', ['$event'])
  onFocusOut(event: MouseEvent): void {
    // Check if the click is outside the dropdown
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.isOpen = false; // Close the dropdown only if the click is outside
    }
  }

  isOpen = false;

  constructor(private elementRef: ElementRef) {}

  // Toggle dropdown
  toggleDropdown(event: MouseEvent) {
    event.stopPropagation(); // Avoid event bubbling
    this.isOpen = !this.isOpen;
  }

  // Toggle group
  toggleGroup(event: MouseEvent, group: any) {
    event.stopPropagation(); // Avoid event bubbling
    group.expanded = !group.expanded;
  }

  // Select group
  selectGroup(event: MouseEvent, group: any) {
    event.stopPropagation(); // Avoid event bubbling
    this.groupSelected.emit(group);
  }

  // Select item
  selectItem(event: MouseEvent, item: any) {
    event.stopPropagation(); // Avoid event bubbling
    this.itemSelected.emit(item);
  }

  shouldShowGroup(group: any): boolean {
    if (group[this.groupItemsProp].length == 0) {
      return false;
    }

    const allItemsExist = group[this.groupItemsProp].every((item: any) =>
      this.selectedItems.some(
        (selectedItem: any) => selectedItem[this.itemIdProp] === item[this.itemIdProp],
      ),
    );

    return !allItemsExist;
  }

  shouldShowItem(item: any): boolean {
    return !this.selectedItems.some(
      (selectedItem: any) => selectedItem[this.itemIdProp] === item[this.itemIdProp],
    );
  }
}
